import Swiper from 'swiper';
import { EffectFade, Keyboard } from 'swiper/modules';
import { Animation } from '../../Animation/src/modules/api.js';

const selectors = {
	animationContainer: 'canvas',
	container: '.milestone',
	slider: '.milestone-slider',
	contentSlider: '.milestone-slider--content > .swiper',
	visualSlider: '.milestone-slider--visual > .swiper',
	yearSlider: '.milestone-slider--years > .swiper',
	hint: '.milestone-slider__hint',
};

const classNames = {
	activeHint: 'active',
	transition: 'transition',
};

document.querySelectorAll(selectors.container).forEach((ctr) => {
	const touchHintClassList = ctr.querySelector(selectors.hint).classList;

	/**
	 * Initialization
	 */
	const sliders = {
		visual: {},
		content: {},
		year: {},
	};

	const fadeSliderConfig = {
		modules: [EffectFade],
		init: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 500,
	};

	sliders.visual.swiper = new Swiper(ctr.querySelector(selectors.visualSlider), fadeSliderConfig);
	sliders.content.swiper = new Swiper(ctr.querySelector(selectors.contentSlider), fadeSliderConfig);
	sliders.year.swiper = new Swiper(ctr.querySelector(selectors.yearSlider), {
		modules: [Keyboard],
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		init: false,
		slidesPerView: 3,
		centeredSlides: true,
		slideToClickedSlide: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 5,
			},
		},
		speed: 500,
	});

	/**
	 * Events
	 */
	// Events: Slide Changed
	sliders.visual.swiper.on('slideChange', (swiper) => {
		sliders.year.swiper.slideTo(swiper.activeIndex);
		sliders.content.swiper.slideTo(swiper.activeIndex);
	});

	sliders.year.swiper.on('slideChange', (swiper) => {
		sliders.visual.swiper.slideTo(swiper.activeIndex);
		sliders.content.swiper.slideTo(swiper.activeIndex);
	});

	sliders.content.swiper.on('slideChange', (swiper) => {
		sliders.visual.swiper.slideTo(swiper.activeIndex);
		sliders.year.swiper.slideTo(swiper.activeIndex);

		// Hide touch hint
		touchHintClassList.contains(classNames.activeHint) && touchHintClassList.remove(classNames.activeHint);
	});

	// Events: Slide Transition
	sliders.year.swiper.on('transitionStart', (swiper) => {
		swiper.el.classList.add(classNames.transition);
	});
	sliders.year.swiper.on('transitionEnd', (swiper) => {
		swiper.el.classList.remove(classNames.transition);
	});
	sliders.content.swiper.on('transitionStart', (swiper) => {
		swiper.el.closest(selectors.slider).classList.add(classNames.transition);
	});
	sliders.content.swiper.on('transitionEnd', (swiper) => {
		swiper.el.closest(selectors.slider).classList.remove(classNames.transition);
	});

	// Events: Animation Handling
	for (const [name, slider] of Object.entries(sliders)) {
		if (['visual', 'content'].includes(name)) {
			// 1. Load all animations
			slider.animations = [];
			slider.swiper.on('init', (swiper) => {
				swiper.slides.forEach((slide, index) => {
					const animationCanvas = slide.querySelector(selectors.animationContainer);
					if (animationCanvas) {
						slider.animations[index] = new Animation(animationCanvas, animationCanvas.getAttribute('data-src'), {
							loop: true,
							autoplay: true,
							workerId: 'milestone',
						});
					}
				});
			});

			// 2. Listen to slideChange event to play / stop animations
			slider.swiper.on('slideChange', (swiper) => {
				// 1. Stop previous animations
				const prevIndex = swiper.previousIndex;
				if (prevIndex !== 'undefined' && prevIndex in slider.animations) {
					slider.animations[prevIndex].stop();
				}

				// 2. Play current animation
				const activeIndex = swiper.activeIndex;
				if (activeIndex in slider.animations) {
					slider.animations[activeIndex].play();
				}
			});
		}

		// Initialize all sliders
		slider.swiper.init();
	}
});
